// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"580":"91c00070567df9ac","1407":"789e684c3611353e","7364":"8492fbcfa3e38854"}[chunkId] + ".js";
};